import React from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'

// @ts-ignore
import PopoverHint from './popover-hint'
import GoodDayUserIcon from "./components/goodday"
import NoneUserIcon from "./components/none"
import User from "../../../model2/user/user";

// nado opredelitsya kakya iz icons normal'nay... a to pipec

type Props = {
    className?      : string
    size            : '18'| '22'| '26'| '30'| '32'| '40'| '54'| '100' // |  'xx?',
    hint?           : true | false | 'up' | 'down' | 'left' | 'right'


    userId          : ID
    dataUserId?     : ID
    addDataUserId?      : ID

    blackWhite?     : boolean
    actionRequired? : boolean             // if set to true ar icon (!) will be added
    assigned?       : boolean                   // if set to true assigned icon (*) will be added (can be both ar + assigned)

    onClick?        : callback
}

type State = {
    hint    : boolean
}

export default class UserIcon extends React.Component<Props, State> {

    // static propTypes = {
    //     size            : PropTypes.oneOf(['18', '22', '26', '30', '32', '40', '54', '100', 'xx?']).isRequired,
    //     hint            : PropTypes.oneOf([true, false, 'up', 'down', 'left', 'right']),
    //
    //
    //     userId          : PropTypes.string,                   // userId
    //     dataUserId      : PropTypes.string,
    //
    //     blackWhite      : PropTypes.bool,
    //     actionRequired  : PropTypes.bool,             // if set to true ar icon (!) will be added
    //     assigned        : PropTypes.bool,                   // if set to true assigned icon (*) will be added (can be both ar + assigned)
    //
    //     onClick         : PropTypes.func,
    // }

    public displayName      : string = 'UserIcon' // what is that ? :)
    public debounceShowHint!      : any
    public debounceHideHint!      : any

    static defaultProps = {
        hint            : false,
        blackWhite      : false,
        actionRequired  : false,
        assigned        : false,
    }

    constructor(props:Props) {
        super(props)

        this.state = {
            hint: false
        }
    }

    componentDidMount() {
        if (this.props.hint) {
            this.debounceShowHint = _.debounce(this._showPopover, 300)
            this.debounceHideHint = _.debounce(this._hidePopover, 400)
        }
    }

    _showPopover = () => {
        if (!this.state.hint) this.setState({hint: true})
    }

    _hidePopover = () => {
        if (this.state.hint) this.setState({hint: false})
    }

    onMouseEnter = () => {
        if (this.props.hint) this.debounceShowHint()
    }

    onMouseLeave = () => {
        if (this.debounceShowHint) this.debounceShowHint.cancel()
        if (this.props.hint) this.debounceHideHint()
    }

    renderSpecialIcon() {
        if (this.props.actionRequired && this.props.assigned) {
            return <span className="ar-as">!*</span>
        } else if (this.props.actionRequired) {
            return <span className="ar">!</span>
        } else if (this.props.assigned) {
            return <span className="as">*</span>
        }
    }

    renderNotActivated(user:User) {

        let colorLetter = user.initials[0].toLowerCase();
        if (colorLetter.match(/[^a-z0-9]/)) {
            colorLetter = 'a' // not latin / digit... set to default "a" potom nado pomenayt' na raznie simvoli konechno
        }

        const classes = Classes('gd-user','not-activated', 'size-'+this.props.size, this.props.className)
        const classesInitials = 'initials i5-user gd-'+colorLetter

        return (
            <div className={classes} data-user-id={this.props.addDataUserId ? user.id : null} onClick={this.props.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <div className={classesInitials}/>
                {this.renderSpecialIcon()}
                {this.state.hint && <PopoverHint userIcon={this} getTargetFunc={()=>findDOMNode(this)} />}
            </div>
        )
    }

    renderWithoutIcon(user:any) {

        let colorLetter = user.initials[0].toLowerCase();
        if (colorLetter.match(/[^a-z0-9]/)) {
            colorLetter = 'a'; // not latin / digit... set to default "a" potom nado pomenayt' na raznie simvoli konechno
        }

        const classes = Classes('gd-user', 'size-'+this.props.size, 's'+user.initials.length, this.props.className, {
            'b-w': this.props.blackWhite
        })
        const classesInitials = 'initials gd-'+colorLetter

        return (
            <div className={classes} data-user-id={this.props.addDataUserId ? user.id : null} onClick={this.props.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <div className={classesInitials}>{user.initials}</div>
                {this.renderSpecialIcon()}
                {this.state.hint && <PopoverHint userIcon={this} getTargetFunc={()=>findDOMNode(this)} />}
            </div>
        )
    }

    renderWithIcon(user?:any) {
        let iconPath, iconClass

        if (user)   iconPath = gdConfig.mediaPath +"user/norm/" + user.icon
        else        iconPath = gdConfig.assetsPath +'/skin/common/svg/gd-avatar.svg'

        switch (this.props.size) {
            case '18'   : iconClass = "size-18"; break
            case '22'   : iconClass = "size-22"; break
            case '26'   : iconClass = "size-26"; break
            case '30'   : iconClass = "size-30"; break
            case '32'   : iconClass = "size-32"; break
            case '40'   : iconClass = "size-40"; break
            case '54'   : iconClass = "size-54"; break
            case '100'  :
                iconClass = "size-100"
                if (user) iconPath = "{0}user/large/{1}".f(gdConfig.mediaPath, user.icon)
                break
            default     :
                console.error("#ridowe unknown size")
                return false
        }

        const classes = Classes('gd-user', 'size-'+this.props.size, 'with-icon', this.props.className, {
            'b-w': this.props.blackWhite,
            'mom': !user,
        });

        return (
            <div className={classes} data-user-id={this.props.addDataUserId && user? user.id : null} onClick={this.props.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <img src={iconPath} />
                {this.renderSpecialIcon()}
                {this.state.hint && <PopoverHint userIcon={this} getTargetFunc={()=>findDOMNode(this)} />}
            </div>
        )
    }

    renderUnknown() {
        const classes = Classes('gd-user', 'unknown', 'size-'+this.props.size, this.props.className, {
            'b-w': this.props.blackWhite
        })

        return (
            <div className={classes} data-user-id={null} onClick={this.props.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <div className="initials"><div className="i5-user"/></div>
                {this.renderSpecialIcon()}
            </div>
        )

    }

    render() {
        if (this.props.userId === 'goodday')    return <GoodDayUserIcon className  = {this.props.className}
                                                                        size       = {this.props.size}/>

        if (this.props.userId === 'unknown')    return this.renderUnknown()
        if (this.props.userId === 'none')       return <NoneUserIcon className  = {this.props.className}
                                                                     size       = {this.props.size}/>

        const user = gd.session.users.get(this.props.userId)
        if (!user) return this.renderWithIcon()

        const companyUser = gd.session.companyUsers.get(gd.companyId+'-'+user.id)
        if (!companyUser || !companyUser.isActivated) return this.renderNotActivated(user)

        if (!user.icon) return this.renderWithoutIcon(user)
        else            return this.renderWithIcon(user)

    }
}
